/* src/app/pages/design-system/design-system.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
:host {
  padding: 32px 24px;
}
h1 {
  color: var(--cds-primary-500);
}
p {
  color: var(--cds-secondary-500);
}
:host {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.icon-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.icon-row i {
  cursor: pointer;
  color: var(--cds-icon-medium);
}
/*# sourceMappingURL=design-system.component.css.map */
